import { AxiosError } from 'axios'
import { flow, makeAutoObservable, observable } from 'mobx'

import { STORE_UI } from 'Core/constants'
import { CustomGenerator } from 'Core/interfaces'
import BasicRootStore from 'Core/stores/basicRootStore/BasicRootStore'

import { HelpCenter } from 'Portals/Customer/entities'
import { HelpCenterRepo } from 'Portals/Customer/repositories'
import i18n from 'Portals/Customer/utils/i18nService'

export class HelpCenterStore {
	rootStore: BasicRootStore
	@observable isRequestSubmitting = false

	constructor(rootStore: BasicRootStore) {
		this.rootStore = rootStore
		makeAutoObservable(this, {}, { autoBind: true })
	}

	@flow
	*sendRequest(payload: HelpCenter.Request): CustomGenerator<void> {
		try {
			this.isRequestSubmitting = true
			yield HelpCenterRepo.sendRequest(payload)
			this.rootStore[STORE_UI].showSuccessNotification(
				i18n.t('core:constants.REQUEST_SUCCESS_MESSAGE')
			)
			this.rootStore[STORE_UI].closeModal()
		} catch (error) {
			this.rootStore[STORE_UI].showErrorNotification(error as AxiosError)
		} finally {
			this.isRequestSubmitting = false
		}
	}
}
